module.exports = __webpack_public_path__ + "img/promo_discount.60cfc64a.svg";